import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;

// Auth is carried by an httpOnly cookie (set by the backend on login) that JS
// cannot read — this is the XSS-safe primary channel. We keep the raw token in
// memory only (never localStorage) for the Authorization header + file-download
// URLs; it is intentionally lost on refresh, at which point the cookie takes over.
let authToken = null;
export function setAuthToken(t) { authToken = t || null; }
export function getAuthToken() { return authToken; }

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  if (authToken) config.headers.Authorization = `Bearer ${authToken}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes('/login')) {
      authToken = null;
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export function downloadUrl(path) {
  // Browser navigations (window.open) can't send an Authorization header, so
  // downloads authenticate via the httpOnly cookie, which is sent automatically.
  // The JWT is intentionally never placed in the URL (avoids leaking it into
  // logs / Referer).
  return `${BASE}/api${path}`;
}

export default api;
